<template>
    <div class="home">
        <!-- banner -->
        <div class="bannner">
            <el-carousel :interval="5000" arrow="always" height="470px" autoplay>
                <el-carousel-item v-for="item in bannerList" :key="item.id">
                    <a
                        :href="item.linkUrl"
                        target="_blank"

                        :style="{backgroundImage: 'url(' + item.imageUrl + ')', backgroundSize:'cover', backgroundPosition:'center', display: 'block', width: '100%', height: '100%'}"
                    ></a>

                </el-carousel-item>
            </el-carousel>
        </div>

        <!-- 公告 -->
        <div class="container notice" v-if="notice">
            <div class="noticeIcon"></div>
            <div class="mainBody">
                <marquee>{{notice.title}}</marquee>
            </div>
            <div class="date">2019.09.09</div>
        </div>

        <!--  宣传页 -->
        <div class="container public">
            <div class="item1">
                <div class="img">
                    <img src="../assets/pub1.png" />
                </div>
                <div class="word1">结构式搜索</div>
                <div class="word2">结构式搜索，准确搜索你想要的</div>
            </div>
            <router-link to="/news-list" class="item2">
                <div class="img">
                    <img src="../assets/pub2.png" />
                </div>
                <div class="word1">新技术资料</div>
                <div class="word2">新技术资料让你获得最新行业资讯</div>
            </router-link>
            <router-link to="/download" class="item3">
                <div class="img">
                    <img src="../assets/pub3.png" />
                </div>
                <div class="word1">产品资料下载</div>
                <div class="word2">产品资料超详细，快速下载</div>
            </router-link>
        </div>

        <!--  特价产品  -->
        <div class="container product" v-if="specialProducts.length > 0">
            <div class="title">
                <p class="title1">明星产品推荐</p>
                <p class="title2">STAR REMCOMMEND PRODUCTS</p>
            </div>
       <!--     <router-link to="/hot/1" class="more">更多>></router-link> -->
            <div class="mingxiimg firstItem">

            </div>
            <div class="rightItem" v-if="specialProducts.length > 2">
                <router-link
                    class="item"
                    v-for="(val, index) in specialProducts"
                    :key="index"
                    :to="'/product-detail/' + val.productId"
                >
                    <div class="img">
                        <img :src="val.structureImage"  @load = "imgLoad" />
                    </div>
                    <div class="name">{{val.productName}}</div>
                    <div class="price">
                        <span class="fontpriceitem">¥{{val.originalMoney}}</span>
                        <span class="priceitem">¥{{val.discountMoney}}</span>
                    </div>
                </router-link>
            </div>
        </div>

        <!--  促销产品  -->
        <div class="container product" v-if="promotionProducts.length > 0">
            <div class="title">
                <p class="title1">促销产品</p>
                <p class="title2">SPECIAL PRODUCTS</p>
            </div>
        <!--     <router-link to="/hot/2" class="more">更多>></router-link> -->
            <div class="cuxiao firstItem">

            </div>
            <div class="rightItem" v-if="promotionProducts.length > 2">
                <router-link
                    class="item"
                    v-for="(val, index) in promotionProducts"
                    :key="index"
                    :to="'/product-detail/' + val.productId"
                >
                    <div class="img">
                        <img :src="val.structureImage"  @load = "imgLoad"/>
                    </div>
                    <div class="name">{{val.productName}}</div>
                    <div class="price">
                        <span class="fontpriceitem">¥{{val.originalMoney}}</span>
                        <span class="priceitem">¥{{val.discountMoney}}</span>
                    </div>
                </router-link>
            </div>
        </div>

        <!-- 新闻轮播 -->
        <div class="container news">
            <el-carousel
                :interval="5000"
                height="280px"
                indicator-position="none"
                arrow="never"
                type="card"
            >
                <el-carousel-item  v-for="(item, index) in newsList" :key="index">
                    <router-link :to="'/news/' + item.articleId" target="_blank" style="width: 100%;height:100%;display: block;">
                        <img :src="item.image" height="100%" />
                    </router-link>
                </el-carousel-item>
                              
            </el-carousel>
        </div>

        <!-- 品牌列表 -->
        <div class="container brand">
            <div class="items">
                <div class="item" v-for="(item, index) in brandList" :key="index">
                    <img :src="item.imageUrl" />
                </div>
            </div>
        </div>


        <!-- 右侧栏 -->
        <div class="fixed">
            <div class="item" @click="toPage('/shopCart')">
                <img src="../assets/home-01.png" alt />
            </div>
            <div class="item" @click="toQQ">
                <img src="../assets/home-02.png" alt />
            </div>
            <div class="item" @click="toPage('/center/order')">
                <img src="../assets/home-03.png" alt />
            </div>
            <!-- <div class="item">
                <img src="../assets/home-04.png" alt />
            </div>-->
            <div class="item qr">
                <img src="../assets/home-05.png" alt />
                <div class="qr-code">
                    <img src="../assets/qrcode.jpeg" alt />
                </div>
            </div>
            <div class="item" @click="toTop" v-if="scrollTop > 600">
                <img src="../assets/home-06.png" alt />
            </div>
            <div class="item" @click="toPage('/promade')">
                <img src="../assets/home-07.png" alt />
            </div>
        </div>
    </div>
</template>

<script>
import * as apis from '../fetch/common';

export default {
    name: 'home',
    data() {
        return {
            bannerList: [],
            brandList: [],
            notice: null,
            specialProducts: [],
            promotionProducts: [],
            scrollTop: 0,
            newsList: []
        };
    },
    methods: {
        imgLoad(self){
           var _img = self.target;
           var _imgWidth = _img.naturalWidth;
           var _imgHeight = _img.naturalHeight;
            if(_imgHeight > 117 || _imgWidth > 117){
                if(_imgHeight-_imgWidth>=0){
                    _img.height = 117;
                    _img.width = 117/_imgHeight*_imgWidth;
                    //$(obj).css("height","161");
                    //$(obj).css("width",161/_imgHeight*_imgWidth);
                }else{
                    _img.width = 117;
                    _img.height = 117/_imgWidth*_imgHeight;
                    //$(obj).css("width","161");
                    //$(obj).css("height",161/_imgWidth*_imgHeight);
                }
            }   
            var height = _img.height/2;
            var width = _img.width/2;

            _img.style.marginTop = -height + "px";
            _img.style.marginLeft = -width + "px";
           // $(obj).css("margin-top",-height);
            //$(obj).css("margin-left",-width);           

        },
        getBannerList() {
            apis.getBanner(1).then(res => (this.bannerList = res));
        },
        getNewList() {
            apis.getNews().then(res => (this.newsList = res));
        },        
        getBrandList() {
            apis.getBrandList().then(res => (this.brandList = res));
        },
        getNotice() {
            apis.getArticleByCategory('notice').then(res => {
                this.notice = res;
            });
        },
        getSpecialProducts() {
            apis.getFeaturedList(8, 1).then(res => {
                this.specialProducts = res;
            });
        },
        getPromotionProducts() {
            apis.getFeaturedList(8, 2).then(res => {
                this.promotionProducts = res;
            });
        },
        toPage(page) {
            this.$router.push(page);
        },
        toQQ() {
            apis.getQqList().then(res => {
                if (res.length > 0) {
                    const url = `http://wpa.qq.com/msgrd?v=3&uin=${res[0].social}&site=qq&menu=yes`;
                    window.open(url);
                } else {
                    this.$message.error('暂无客服');
                }
            });
        },
        toTop() {
            window.scrollTo(0, 0);
        },
        onScroll() {
            window.addEventListener('scroll', () => {
                const scrollTop =
                    window.pageYOffset ||
                    document.documentElement.scrollTop ||
                    document.body.scrollTop;
                this.scrollTop = scrollTop;
            });
        },
    },
    mounted() {
        this.getBannerList();
        this.getNewList();
        this.getBrandList();
        this.getNotice();
        this.getSpecialProducts();
        this.getPromotionProducts();
        this.onScroll();
    },
};
</script>

<style lang="less" scoped>
p {
    margin: 0;
}

.fixed {
    width: 50px;
    position: fixed;
    bottom: 50px;
    right: 30px;
    z-index: 99;
    .item {
        width: 50px;
        height: 50px;
        margin-bottom: 5px;
        cursor: pointer;
        position: relative;
        img {
            width: 50px;
            height: 50px;
        }
    }
    .qr {
        &:hover {
            .qr-code {
                display: block;
            }
        }
        .qr-code {
            width: 150px;
            height: 150px;
            background-color: #fff;
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
            position: absolute;
            top: -50px;
            right: 70px;
            border-radius: 6px;
            padding: 5px;
            display: none;
            img {
                width: 100%;
                height: 100%;
            }
        }
        .qr-code::after {
            content: '';
            position: absolute;
            border-left: 10px solid #fff;
            border-top: 10px solid transparent;
            border-bottom: 10px solid transparent;
            top: 68px;
            right: -10px;
        }
    }
}

.search {
    height: 90px;
    position: relative;
}

.search .logo {
    position: absolute;
    top: 15px;
    left: 0px;
    height: 60px;
    width: 200px;
    background: url(../assets/logo.png) no-repeat;
    background-size: 100%;
}

.searchInput {
    outline: none;
    border: 0;
    width: 600px;
    height: 40px;
    position: absolute;
    top: 25px;
    right: 120px;
    padding: 0 60px 0 10px;
    border-radius: 8px;
}

.searchIcon {
    position: absolute;
    top: 25px;
    right: 120px;
    width: 40px;
    height: 40px;
    background: url(../assets/searchIcon.png) no-repeat center;
}

.structButton {
    position: absolute;
    top: 25px;
    right: 0px;
    width: 100px;
    height: 40px;
    line-height: 40px;
    color: #ffffff;
    background-color: #3c9539;
    border-radius: 8px;
    border: 0;
}

.bannner {
    width: 100%;
}

.notice {
    margin-top: 20px;
    height: 52px;
    line-height: 52px;
    display: flex;
    background: #ffffff;
    font-size: 14px;
    color: #a2a7b7;
    .noticeIcon {
        width: 60px;
        background: url('../assets/notic.png') no-repeat;
        background-position: 78% 50%;
    }
    .mainBody {
        flex: 1;
        padding: 0 10px;
    }
    .date {
        width: 100px;
    }
}

.public {
    margin-top: 20px;
    position: relative;
    height: 300px;
    .item1 {
        position: absolute;
        left: 0;
        width: 300px;
        background: #ffffff;
        height: 280px;
        top: 0;
        border-radius: 20px;
        cursor: pointer;
    }
    .item2 {
        position: absolute;
        left: 450px;
        width: 300px;
        height: 280px;
        background: #ffffff;
        top: 0;
        border-radius: 20px;
        cursor: pointer;
    }
    .item3 {
        position: absolute;
        right: 0;
        width: 300px;
        height: 280px;
        background: #ffffff;
        top: 0;
        border-radius: 20px;
        cursor: pointer;
    }
    .img {
        width: 300px;
        img {
            width: 100%;
        }
    }
    .word1 {
        text-align: center;
        height: 45px;
        line-height: 45px;
        font-size: 16px;
        font-family: PingFangSC-Regular;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #3a3a3a;
    }
    .word2 {
        text-align: center;
        font-family: PingFangSC-Regular;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #646464;
    }
}

.product {
    margin-top: 20px;
    position: relative;
    .title {
        height: 50px;
        .title1 {
            font-size: 20px;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 2px;
            color: #282b35;
        }
        .title2 {
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 0px;
            color: rgba(188, 192, 205, 0.4);
        }
    }
    .more {
        position: absolute;
        right: 0;
        height: 50px;
        top: 0;
        line-height: 70px;
        font-size: 12px;
        right: 10px;
        cursor: pointer;
        color: #333;
    }
    .mingxiimg{
         background: url('../assets/mingxin.jpg') 100%;
    }
    .cuxiao{
        background: url('../assets/cuxiao.jpg') 100%;
    }
    .firstItem {
        margin-top: 10px;
        height: 500px;
        width: 250px;
        position: relative;
        text-align: center;
        border-radius: 10px;
        .name {
            position: absolute;
            bottom: 80px;
            width: 100%;
            color: #000000;
            font-size: 16px;
        }
        .price {
            position: absolute;
            bottom: 60px;
            width: 100%;
            color: #000000;
            font-size: 12px;
            color: rgba(0, 0, 0, 0.4);
            text-decoration: line-through;
        }
        .salePrice {
            position: absolute;
            bottom: 40px;
            width: 100%;
            color: #000000;
            font-size: 14px;
            color: #ff9236;
        }
    }
    .rightItem {
        position: absolute;
        top: 60px;
        right: -20px;
        bottom: -20px;
        width: 950px;
        height: 520px;
        .item {
            float: left;
            width: 217px;
            height: 238px;
            background: #ffffff;
            margin-right: 20px;
            margin-bottom: 20px;
            border-radius: 10px;
            color: #333;
            overflow: hidden;
            .img {
                height: 166px;
                border-bottom: 1px dashed #eeeeee;
                padding: 24px 50px;
                position:relative;
                img {
                    position:absolute;
                    top:50%;
                    left:50%;
                }
            }
            .name {
                height: 40px;
                line-height: 40px;
                padding: 0 15px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;                
            }

            .price {
                padding: 0 15px;
                .fontpriceitem {
                    text-decoration: line-through;
                    font-size: 14px;
                    color: rgba(0, 0, 0, 0.4);
                }
                .priceitem {
                    color: #ff9236;
                    float: right;
                }
            }
        }
    }
}

.news {
    margin-top: 40px;
    height: 280px;
    text-align: center;
}

.brand {
    margin-top: 40px;
    height: 146px;
    .items {
        width: 1264px;
        .item {
            float: left;
            width: 143px;
            height: 65px;
            margin: 0 8px 8px 0;
            border-radius: 10px;
            overflow: hidden;

            img {
                width: 100%;
                height: 100%;
                border: none;
            }
        }
    }
}


</style>